module.exports = "h4{\r\n    padding-top:10px;\r\n    padding-left:10px;\r\n}"